import cx from 'classnames';
import config from '@plone/registry';

import CTA from '@redturtle/qubicaamf-theme/components/Blocks/commons/CTA';
import Carousel from '../Listing/Carousel/Carousel';
import type { BowlingCenterCarouselViewProps } from './View';
import styles from './styles.module.css';

interface BodyProps extends BowlingCenterCarouselViewProps {}

const Body = ({ data, content }: BodyProps) => {
  const slidesItems = content.bowling_center_products;
  const SlideComponent =
    // @ts-expect-error
    config.settings['volto-carousel'].slide_appearances?.['default']?.component;

  let carouselOptions = {
    slidesPerView: data.slides_to_show ?? slidesItems.length,
    spaceBetweem: data.space_between ?? 0,
    autoHeight: true,
  };

  return (
    <>
      {data.title && (
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>{data.title}</h2>
        </div>
      )}
      <div className={cx('carousel-wrapper', styles.carouselWrapper)}>
        <Carousel
          items={slidesItems}
          slideComponent={({ item, index }) => (
            <SlideComponent
              item={item}
              index={index}
              TitleTag="h3"
              isEditMode={true}
              data={data}
              show_description={true}
            />
          )}
          full_width={data.styles?.fullwidth}
          {...carouselOptions}
        />
      </div>
      {data.linkHref?.[0] && (
        <div className={styles.ctaContainer}>
          <CTA
            href={data.linkHref[0]['@id']}
            openLinkInNewTab={false}
            ctaButtonStyle={data.ctaButtonStyle}
            linkIcon={data.linkIcon}
            cta_color={data.cta_color}
          >
            {data.linkTitle}
          </CTA>
        </div>
      )}
    </>
  );
};

export default Body;
